export var store = {
  _origin: 'https://api.emailjs.com'
};